import styled from 'styled-components';

export const Wrapper = styled.div`
  font-size: 18em;
  padding: 4px 14px 4px 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  border-radius: 12px 0 0 12px;
  background: white;
  color: var(--mantine-color-orange-6);
  border: 2px solid red;
  font-weight: bold;
  text-shadow: 1px 1px 3px rgba(255, 0, 0, 0.3);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), inset 0 2px 4px rgba(255, 0, 0, 0.2);
`;
